import { render, staticRenderFns } from "./gbb-qrCode-scan.vue?vue&type=template&id=a93bbc0c&scoped=true&"
import script from "./gbb-qrCode-scan.vue?vue&type=script&lang=js&"
export * from "./gbb-qrCode-scan.vue?vue&type=script&lang=js&"
import style0 from "./gbb-qrCode-scan.vue?vue&type=style&index=0&id=a93bbc0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93bbc0c",
  null
  
)

export default component.exports